import ArrowBackIosNewOutlined from '@mui/icons-material/ArrowBackIosNewOutlined';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import { CircularProgress, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

function NotFound({ loading }: { loading: boolean }) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingTop: '30vh',
            }}
        >
            {loading ? (
                <>
                    <Typography sx={{ paddingY: 5 }} variant="h4">
                        Loading
                    </Typography>
                    <CircularProgress sx={{ alignSelf: 'center', marginBottom: 10 }} />
                </>
            ) : (
                <>
                    <Link to="/">
                        <HelpOutlineOutlined style={{ fontSize: '4rem' }} />
                    </Link>
                    <Typography sx={{ paddingY: 5 }} variant="h2">
                        Page not found!
                    </Typography>
                </>
            )}
            <Link to="/" style={{ display: 'flex' }}>
                <ArrowBackIosNewOutlined fontSize="large" style={{ marginTop: 3 }} />
                <Typography sx={{ paddingLeft: 2 }} variant="h4">
                    {'Go Back'}
                </Typography>
            </Link>
        </div>
    );
}

export default NotFound;
